import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";

export function scrollToId(id) {
  const element = document.getElementById(id);
  if (!element) return;

  const navHeight = Number.parseFloat(
    getComputedStyle(document.documentElement).getPropertyValue("--nav-h")
  );
  const offset = Number.isFinite(navHeight) ? navHeight + 16 : 88;
  const top = element.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top, behavior: "smooth" });
}

export function Navigation() {
  const { t, i18n } = useTranslation("global");
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const links = [
    ["ecosystem", "ecosystem"],
    ["sectors", "sectors"],
    ["gallery", "gallery"],
    ["contact", "contact"],
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavigation = (event, id) => {
    event.preventDefault();
    scrollToId(id);
    setIsOpen(false);
  };

  return (
    <motion.nav
      className={`siat-nav${scrolled ? " is-scrolled" : ""}`}
      aria-label="Main navigation"
      initial={{ y: -24, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
    >
      <a
        className="siat-nav__brand siat-brand"
        href="#top"
        onClick={(event) => handleNavigation(event, "top")}
      >
        <img src="/img/logodorado.png" alt="SIAT" className="siat-nav__logo" width="36" height="36" />
      </a>
      <button
        className="siat-nav__toggle"
        type="button"
        aria-expanded={isOpen}
        aria-controls="siat-nav-links"
        aria-label="Toggle navigation"
        onClick={() => setIsOpen((open) => !open)}
      >
        <span />
        <span />
        <span />
      </button>
      <div
        className={`siat-nav__links${isOpen ? " is-open" : ""}`}
        id="siat-nav-links"
      >
        {links.map(([key, id]) => (
          <a
            key={id}
            className="siat-nav__link"
            href={`#${id}`}
            onClick={(event) => handleNavigation(event, id)}
          >
            {t(`navigation.${key}`)}
          </a>
        ))}
        <div className="siat-nav__actions">
          <a
            className="siat-btn siat-btn--primary"
            href="#download"
            onClick={(event) => handleNavigation(event, "download")}
          >
            {t("navigation.download")}
          </a>
          <label className="siat-nav__language">
            <span className="sr-only">Language</span>
            <select
              value={i18n.language?.split("-")[0] || "es"}
              onChange={(event) => i18n.changeLanguage(event.target.value)}
            >
              <option value="es">ES</option>
              <option value="en">EN</option>
            </select>
          </label>
        </div>
      </div>

      <AnimatePresence>
        {isOpen ? (
          <motion.button
            type="button"
            className="siat-nav__backdrop"
            aria-label="Close menu"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsOpen(false)}
          />
        ) : null}
      </AnimatePresence>
    </motion.nav>
  );
}
